import React, { useEffect, useState } from "react";
import Paper from '@mui/material/Paper';
import VirtualizedTable from "../components/VirtualizedTable";
import { Redirect } from "react-router-dom";

import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import DoneIcon from '@mui/icons-material/Done'
import Instructions from '../components/Instructions'
import GPAP_Button from "../../../../gpap-lib/Button_Collection";
import { GPAP_Button_light } from "../../../../gpap-lib/Button_Collection";
import {closefilesubmission, send_mail} from "../../../service/apis"
import CircularProgress from '@mui/material/CircularProgress';
import { red } from '@mui/material/colors';
import Divider from '@mui/material/Divider';
import Chip from '@mui/material/Chip';
import Box from '@mui/material/Box';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';


import auth from '../../../service/Auth';
import AuthErrorDialog from "../components/AuthError";


const config = window.config;

const dataHeader = [
    { label: "Local Experiment ID", dataKey: "LocalExperimentID", width: 185}, 
    { label: "Participant ID", dataKey: "Participant_ID", width: 130},
    { label: "Experiment ID", dataKey: "ExperimentID", width: 130},
    { label: "File list", dataKey: "fileList", width: 455}
];

const SubmissionExperimentClose =(props)=> {

    const [experimentSelected, setExperimentsSelected] = useState([]);
    const [data, setData] = useState([]);
    const [next, setNext] = useState(false);
    const [close, setClose] = useState(false);
    const [load, setLoad] = useState(false);
    const [error, setError] = useState("");
    const [authError, setAuthError] = useState("");

    const formatRows = (contents) => {
        // 1. From recieved contents build table rows
        if (contents.length > 1){
            // 1.1 Define header name and indexes
            let headerList = {};
            contents[0].forEach((element, index) => {
                headerList[element] = index;    
            });
            // 1.2 Loop over all contents 
            let experimentFiles = {};
            contents.forEach((row, index) => {
                if (index > 0) {
                    let experimentID = row[headerList[config.platform_label + " ID Experiment"]];
                    let participantID = row[headerList["Participant ID "]];
                    let localExperimentID = row[headerList["Local submitter ID"]];
                    let fileName = row[headerList["File Name"]];
                    // 1.2.1 Update experiment files
                    if (experimentID in experimentFiles) {
                        experimentFiles[experimentID].fileList.push(fileName);
                    } else {
                        experimentFiles[experimentID] = {
                            "ExperimentID": experimentID,
                            "Participant_ID": participantID,
                            "LocalExperimentID": localExperimentID,
                            "fileList": [fileName]
                        };
                    }
                }
            });
            // 1.2 Format data for Virtualized Table
            let rowsTable = [];
            let nRow = 0;
            for (const [exp, expValues] of Object.entries(experimentFiles)) {
                let row = {
                    "LocalExperimentID": expValues.LocalExperimentID,
                    "Participant_ID": expValues.Participant_ID,
                    "ExperimentID": expValues.ExperimentID,
                    "fileList": expValues.fileList.join(' '),
                    "id": nRow
                }
                rowsTable.push(row);
                nRow = nRow + 1;
            }
            setData(rowsTable);
            setExperimentsSelected(rowsTable.map((item) => { return item.id }));
        }
    }

    useEffect(() => {  
        if (auth.tokenExpired()){  
            setAuthError("Logging session timeout. Please log again");
        }else{
            // 1. Get total items to render on table from props 
            formatRows(props.location.contents);
            setLoad(true);
        }            
    }, [])

    const closeExperimentSubmissionButton = async (event) => {
        // 1. Get all experiments ID Selected
        const experimentIDs = data.filter(item => experimentSelected.includes(item.id)).map(item => item.ExperimentID);
        // 2. Build body POST 
        const body = {"experiments_close": experimentIDs};
        // 2. Perform REST API query
        const response = await closefilesubmission(auth.getToken(),config.api_endpoint,JSON.stringify(body));
        if (response.status !== 200){
            setError("Sorry!! Can not Update Experiments due to " + response.statusText);
        }
        else{
            /*Go to Main Page*/
            setNext(true);
        }
    }

    const skipButton = (event) => {
        setNext(true);
    }

    const getMailBody = () => { 
        /* 1. Define table of files */
        let samples = "<table>";
        samples += " <tr>";
        samples += "     <th>Submitter ID</th>";
        samples += "     <th>Participant ID</th>";
        samples += "     <th>Experiment ID</th>";
        samples += "     <th>File submission closed</th>";
        samples += "     <th>File name list</th>";
        samples += " </tr>";
        /* 2. Fullfill contents*/
        samples +=  data.map(item => {  let submission = (experimentSelected.includes(item.id) && next) ? "CLOSED" : "OPEN"; 
                                        return "<tr><td>" + item.LocalExperimentID + "</td>" + 
                                             "<td>" + item.Participant_ID + "</td>" +
                                             "<td>" + item.ExperimentID + "</td>" +
                                             "<td>" + submission + "</td>" + 
                                             "<td>" + item.fileList + "</td> </tr>"});
        samples += "</table>";
        /* 3. Main Text*/
        const name = auth.getUser().keycloak.tokenParsed.given_name;
        const surnames = auth.getUser().keycloak.tokenParsed.family_name;
        let body = "Dear " + name + " " + surnames + ", <br>";
        body += "Thank you for your submission. <br>";
        body += "If you currently have an active Aspera account please upload your raw data. <br>";
        body += "If you don't have an active Aspera account, then you will receive in the next 24 hours an email containing the credentials necessary for uploading your genomics data to our server. <br>";
        body += "Once you receive this, you will need to:<br> <br>";
        body += "1) Log-in to the file transfer server using the credentials provided <br>";
        body += "2) Upload the corresponding FASTQ (or BAM) files shown in the table below<br>";
        body += " <br> " + samples + "<br>";
        body += "Note:<br>";
        body += "If you have any problems, or questions, please do not hesitate to contact "+ config.help_mail +".<br>";
        return body;
    }

    const sendNotificationMail = async() => {
        let body = getMailBody();
        await send_mail(auth.getToken(),config.api_endpoint,JSON.stringify({"subject":"Submission of Sample file/s","body":body}));
    }

    const NotificationMailPanel = () => {
        return (
            <Snackbar
                anchorOrigin={{ horizontal:'center', vertical:'top' }}
                open={true}  autoHideDuration={4000} onClose={() => setClose(true)}>
                <Alert elevation={6} severity="success" variant="filled">
                    An email describing your submission has been sent to your mail account. 
                </Alert>
            </Snackbar>
        );
    }

    /* OpenID session token error*/
    if (authError !== "" ) {
        return (
            <AuthErrorDialog errors={authError} open={true}/>
        );
    }

    if(close) {
        sendNotificationMail(); 
        return <Redirect to={{pathname:'/'}}/>
    }
   
    return (
        <div className={"mainContent"}>
            {
                    /*Show Mail Notification*/  
                    (next) ? <NotificationMailPanel/> : null
            }
            <Grid container spacing={3}>
                <Grid item xs> </Grid>
                <Grid item xs={6} justifyContent="center">
                    <Typography variant={"h5"} align={"center"}> Close Experiment File Submission </Typography>
                    <Box sx={{ m: 2 }}>
                        <Divider>
                            <Chip label="INFO" />
                        </Divider>
                        <Typography sx={{m:1}} variant="subtitle1"> 
                            Unmark those experiments where more file metadata will be submitted. 
                            Keep marked those ones that are ready to start its analysis. <br/>
                        </Typography>
                        <Divider/>
                    </Box>
                    {   error ?
                            <Typography variant={"h5"} sx={{color:red[900]}}> 
                               {error}
                            </Typography>
                        :
                            null
                    }
                </Grid>
                <Grid item xs> </Grid>
            </Grid>

            { load ?
                <Grid container justifyContent="center" alignItems="center" direction="column" spacing={2}>
                    <Paper component={Grid} 
                           container 
                           item
                           elevation={1}
                           style={{ height: 400, width: 900 }}
                           sx={{m:2}}
                           spacing={2}>
                                <VirtualizedTable columns={[{dataKey:"checkbox"},...dataHeader]} 
                                                  rowCount={data.length}
                                                  rowGetter={({ index }) => data[index]}
                                                  rows={data}
                                                  checkedRows={experimentSelected} 
                                                  setCheckedRows={setExperimentsSelected} /> 
                       
                    </Paper>
                    <Grid item>
                        <Grid container direction="row" justifyContent="space-between" alignItems="center" spacing={2}>
                            <Grid item >
                                <GPAP_Button_light onClick={skipButton}> 
                                    SKIP
                                </GPAP_Button_light>
                            </Grid>
                            <Grid item >
                                <GPAP_Button onClick={closeExperimentSubmissionButton} startIcon={<DoneIcon/>}> 
                                    CLOSE SUBMISSION FOR SELECTED EXPERIMENTS
                                </GPAP_Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            : 
                <Grid container justifyContent="center" alignItems="center" direction="row" spacing={2}>
                    <Grid item>
                        <CircularProgress />
                    </Grid>               
                </Grid>
            }
        </div>
    )
}

export default SubmissionExperimentClose;
